<template>
    <div style="width: 100vw;height: 100vh;background-color: white;overflow-y: auto;">
        <div class="topContainer">
            <p style="font-weight: bold;font-size: 22px;color: #4a8af4;margin: 0px;">Reachable Email System</p>
            <div style="display: flex;justify-content: center;align-items: center;">
                <el-button type="success" style="margin-left: 20px;" size="small" @click="createNewEmail">New
                    Email</el-button>
            </div>
        </div>
        <div
            style="width: 100vw;;display: flex;margin-top: 60px;height: calc(100vh - 60px); overflow-y: auto;position: relative;">
            <el-tabs v-model="currentTab" tab-position="left" @tab-click="handleTabClick" class="el-tabs-content">
                <el-tab-pane label="InBox" name="first">
                </el-tab-pane>
                <el-tab-pane label="OutBox" name="second">
                </el-tab-pane>
                <el-tab-pane label="Settings" name="third">
                </el-tab-pane>
                <el-tab-pane label="Stats" name="fourth">
                </el-tab-pane>
                <el-tab-pane label="MailSign" name="five">
                </el-tab-pane>
                <el-tab-pane label="DeletedMail" name="six">
                </el-tab-pane>
                <el-tab-pane label="BlackList" name="seven">
                </el-tab-pane>
            </el-tabs>
            <div style="flex: 1;height: 100%;overflow-y: auto;">
                <EmailNav :type="'in'" :operators="employees" v-if="currentTab == 'first'" :emails="inList" ref="inNav"
                    :page="inPage"
                    @emailDeleted="handleEmailDeleted"
                    @handleFilterEmailRequest="handleFilterEmailRequest" @handleInSelectMail="handleInSelectMail"
                    class="nav-content">
                </EmailNav>
                <EmailNav :type="'out'" :page="outPage"  :operators="employees" v-if="currentTab == 'second'" :emails="outList"
                    ref="outNav" @handleFilterEmailRequest="handleFilterEmailRequest"
                    @emailDeleted="handleEmailDeleted"
                    @handleOutSelectMail="handleOutSelectMail" class="nav-content">
                </EmailNav>
                <div v-if="currentTab == 'third'" style="flex: 1;">
                    <EmailSettings @handleEmailsChanged="requestSenderEmails"></EmailSettings>
                </div>
                <div v-if="currentTab == 'five'" style="flex: 1;">
                    <EmailSign @handleEmailSignChanged="requestEmailSigns"></EmailSign>
                </div>
                 <div v-if="currentTab == 'six'" style="flex: 1;">
                    <RemovedMails ></RemovedMails>
                </div>
                  <div v-if="currentTab == 'seven'" style="flex: 1;">
                    <blackMails></blackMails>
                </div>
            </div>
        </div>

        <el-drawer size="90%" :visible.sync="showDrawer" :with-header="false" direction="rtl">
            <div style="display: flex;">
                <EmailEditor :showType="currentTab == 'first' ? 'in' : 'out'" :allProjects="allProjects"
                    :emailSignList="emailSignList" :mail_id="select_mail_id" :emails="emails" ref="emailEditor"
                    class="email-editor-width content-height" @showReplyUserDialog="doShowReplyUserDialog"
                    @clientDatasCallback="showClientDatas" @refreshNavSingleEmail="refreshNavSingleEmail"
                    @refreshCurrentTabEmails="refreshCurrentTabEmails" @refreshEmails="refreshOutBox"
                    @emailDeleted="handleEmailDeleted">
                </EmailEditor>
                <ClientDatasView :mail_id="select_mail_id" v-if="showClientDataView == true"
                    :mail_type="currentTab == 'first' ? 'in' : 'out'" style="width: 400px;" :clientData="clientDatas">
                </ClientDatasView>
            </div>
        </el-drawer>

        <el-dialog :visible.sync="showReplyUserDialog" title="Assign Employee to Reply Email" :modal="false"
            :append-to-body="true" width="45%">
            <div>
                <el-form>
                    <el-form-item label="Select Employee">
                        <el-select v-model="assignEmployeeInfo.employee_id" placeholder="Please select"
                            style="width: 400px;">
                            <el-option value="-1" label="Not Assigned"></el-option>
                            <el-option v-for="(user, index) in employees" :key="index"
                                :label="user.user_lastName + user.user_givenName" :value="user._id.$id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                    <el-button @click="showReplyUserDialog = false">Cancel</el-button>
                    <el-button type="primary" @click="confirmSelectEmployee">Confirm</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    postRequest,
    getEmailSigns,
    assignMailToEmployeeReply,
    getFullTimeEmployees,
    getCompanyEmailsV1,
    getAllProjects
} from '../../api/assistant'
import EmailNav from '../../components/Email/nav.vue'
import EmailEditor from '../../components/Email/edit.vue'
import EmailSettings from '../../components/Email/settings.vue'
import EmailSign from '../../components/Email/sign.vue'
import RemovedMails from '../../components/Email/removedMails.vue'
import blackMails from '../../components/Email/blackMails.vue'
import ClientDatasView from '../../components/Email/client_datas.vue'
import { Loading } from 'element-ui'
import {
    getUserId
} from '../../utils/store'
export default ({
    name: 'index',
    components: {
        ClientDatasView,
        EmailNav, EmailEditor, EmailSettings, EmailSign,RemovedMails,blackMails
    },
    data() {
        return {
            key_word: '',
            limit_size: 100,
            inPage: 0,
            outPage: 0,
            showDrawer: false,
            requestBySearch: false,
            emailSignList: [],
            allProjects: [],
            showClientDataView: false,
            clientDatas: {},
            select_mail_id: '',
            inList: [],
            outList: [],
            currentTab: 'first',
            employees: [],
            emails: [],
            showReplyUserDialog: false,
            assignEmployeeInfo: {
                mail_id: '',
                employee_id: ''
            },
            loading: false,
            inRequestParams: {
                function: 'requestNewEmails',
                request_type: 'refresh',
                in_out: 'in',
                limit_size: 100,
                skip_size: 0,
                sender_id: getUserId(),
                key_word: ''
            },
            outRequestParams: {
                function: 'requestNewEmails',
                request_type: 'refresh',
                in_out: 'out',
                limit_size: 100,
                skip_size: 0,
                sender_id: getUserId(),
                key_word: ''
            }
        }
    },
    mounted() {
        this.fetchData('refresh', {}, false)
        this.initDatas()
    },
    methods: {

        refreshNavSingleEmail(mail) {
            if (this.currentTab == 'first' || this.currentTab == 'second') {
                if (this.currentTab == 'first') {
                    if (this.$refs.inNav) {
                        this.$refs.inNav.refreshSingleMail(mail)
                    }
                } else {
                    if (this.$refs.outNav) {
                        this.$refs.outNav.refreshSingleMail(mail)
                    }
                }
            }
        },

        showClientDatas(clientDatas) {
            this.showClientDataView = true
            this.clientDatas = clientDatas
        },

        confirmSelectEmployee() {
            if (this.assignEmployeeInfo.employee_id == '') {
                this.$message.warning('Please select')
                return
            }
            this.showClientDataView = false
            assignMailToEmployeeReply(this.assignEmployeeInfo.mail_id, this.assignEmployeeInfo.employee_id).then((res) => {
                this.$message.success('Assigned success~')
                this.showReplyUserDialog = false
                // this.showDrawer = false
                this.select_mail_id = this.assignEmployeeInfo.mail_id
                this.$nextTick(() => {
                    this.$refs.emailEditor.doShowReplyInstructionDialog()
                })
                this.fetchData('refresh', {}, '')
            })
        },

        doShowReplyUserDialog(mail_id) {
            this.assignEmployeeInfo = {
                mail_id: mail_id,
                employee_id: ''
            }
            this.showReplyUserDialog = true
        },

        async requestEmailSigns() {
            let emailSignListResult = await getEmailSigns()
            this.emailSignList = emailSignListResult.data
        },
        async requestSenderEmails() {
            let companyEmailResult = await getCompanyEmailsV1()
            this.emails = companyEmailResult.data
        },

        async initDatas() {
            let employeeResult = await getFullTimeEmployees(getUserId())
            this.employees = employeeResult.data.data

            let projectResult = await getAllProjects()
            this.allProjects = projectResult.data.data

            this.requestSenderEmails()
            this.requestEmailSigns()

        },

        handleEmailDeleted() {
            this.showDrawer = false
            this.showClientDataView = false
            this.select_mail_id = ''
            this.fetchData('refresh', {}, '')
        },

        refreshCurrentTabEmails() {
            this.showDrawer = false
            this.showClientDataView = false
            this.$nextTick(() => {
                this.fetchData('refresh', {}, '')
            })
        },

        refreshOutBox() {
            this.showDrawer = false
            this.showClientDataView = false
            this.currentTab = 'second'
            this.$nextTick(() => {
                this.fetchData('refresh', {}, '')
            })
        },

        handleTabClick(tab, event) {
            this.showClientDataView = false
            if (this.currentTab == 'first' || this.currentTab == 'second') {
                this.select_mail_id = ''
                if (this.currentTab == 'first') {
                    if (this.$refs.outNav) {
                        this.$refs.outNav.resetSelectMailIndex()
                    }
                } else {
                    if (this.$refs.inNav) {
                        this.$refs.inNav.resetSelectMailIndex()
                    }
                }
                this.fetchData('refresh', {}, '')
            }
        },

        createNewEmail() {
            this.select_mail_id = ''
            this.showDrawer = true
            this.showClientDataView = false
            this.$nextTick(() => {
                this.$refs.emailEditor.createNewEmail()
            })
        },

        handleInSelectMail(mail) {
            this.showDrawer = true
            this.select_mail_id = mail._id.$id
            this.$nextTick(() => {
                this.$refs.emailEditor.showContentView()
            })
        },
        handleOutSelectMail(mail) {
            this.showDrawer = true
            this.select_mail_id = mail._id.$id
            this.$nextTick(() => {
                this.$refs.emailEditor.showContentView()
            })
        },

        handleFilterEmailRequest(params) {
            let page = params.page
            let new_params = params.params
            if (page == 'init') {
                this.fetchData('init', {}, '')
            } else if (page == 'search') {
                this.fetchData(page, new_params, '')
            } else if (page == 'reset') {
                this.fetchData('reset', new_params, '')
            } else if (Object.keys(new_params).length > 0) {
                this.fetchData('filter', new_params, page)
            } else if (page == 'next_page' || page == 'pre_page') {
                this.fetchData('request_page', {}, page)
            }
        },

        async fetchData(request_type, filterParams, page) {
            this.loading = true
            let loadingInstance = Loading.service({
                text: 'Loading',
                fullscreen: true
            })
            try {
                let params = {}
                if (request_type == 'init') {
                    if (this.currentTab == 'first') {
                        this.inPage = 0
                        params = {
                            function: 'requestNewEmails',
                            request_type: 'refresh',
                            in_out: 'in',
                            limit_size: 100,
                            skip_size: 0,
                            sender_id: getUserId(),
                            key_word: ''
                        }
                    } else {
                        this.outPage = 0
                        params = {
                            function: 'requestNewEmails',
                            request_type: 'refresh',
                            in_out: 'out',
                            limit_size: 100,
                            skip_size: 0,
                            sender_id: getUserId(),
                            key_word: ''
                        }
                    }
                } else if (request_type == 'refresh') {
                    let skip_size = 0
                    if (this.currentTab == 'first') {
                        skip_size = this.inPage * this.limit_size - 1
                    } else {
                        skip_size = this.outPage * this.limit_size - 1
                    }
                    if (skip_size <= 0) {
                        skip_size = 0
                    }
                    if (this.currentTab == 'first') {
                        this.inRequestParams.skip_size = skip_size
                        params = this.inRequestParams
                    } else {
                        this.outRequestParams.skip_size = skip_size
                        params = this.outRequestParams
                    }
                } else if (request_type == 'reset') {
                    let skip_size = 0
                    if (this.currentTab == 'first') {
                        this.inPage = 0
                    } else {
                        this.outPage = 0
                    }
                    if (this.currentTab == 'first') {
                        this.inRequestParams.skip_size = skip_size
                        params = this.inRequestParams
                    } else {
                        this.outRequestParams.skip_size = skip_size
                        params = this.outRequestParams
                    }
                } else if (request_type == 'search') {
                    let type = 'out'
                    if (this.currentTab == 'first') {
                        type = 'in'
                    }
                    params = {
                        function: 'requestNewEmails',
                        request_type: 'search',
                        in_out: type,
                        limit_size: this.limit_size,
                        skip_size: 0,
                        sender_id: getUserId(),
                        key_word: filterParams
                    }
                } else {
                    let type = 'out'
                    let skip_size = 0
                    if (this.currentTab == 'first') {
                        type = 'in'
                        if (page == 'next_page') {
                            this.inPage++
                        } else if (page == 'pre_page') {
                            this.inPage--
                            if (this.inPage <= 0) {
                                this.inPage = 0
                            }
                        }
                        skip_size = this.inPage * this.limit_size - 1
                    } else {
                        if (page == 'next_page') {
                            this.outPage++
                        } else if (page == 'pre_page') {
                            this.outPage--
                            if (this.outPage <= 0) {
                                this.outPage = 0
                            }
                        }
                        skip_size = this.outPage * this.limit_size - 1
                    }
                    if (skip_size <= 0) {
                        skip_size = 0
                    }
                    params = {
                        function: 'requestNewEmails',
                        request_type: request_type,
                        in_out: type,
                        limit_size: this.limit_size,
                        skip_size: skip_size,
                        sender_id: getUserId(),
                        key_word: this.key_word
                    }
                }
                if (filterParams && Object.keys(filterParams).length > 0 && request_type != 'search') {
                    params.request_type = 'filter'
                    params.filers = filterParams
                }
                if (params.in_out == 'in') {
                    this.inRequestParams = params
                } else {
                    this.outRequestParams = params
                }
                let res = await postRequest(params)
                if (this.currentTab == 'first') {
                    this.inList = res.data
                } else {
                    this.outList = res.data
                }
            } finally {
                this.loading = false
                loadingInstance.close()
            }
        }
    }
})
</script>
<style scoped lang="scss">
.el-tabs-content {
    width: 100px;
    height: calc(100vh - 60px);
    overflow-y: auto;
}

::-webkit-scrollbar {
    display: none;
}

.email-editor-width {
    width: 100%;
}

.content-height {
    height: calc(100vh - 60px);
}

.nav-content {
    height: calc(100vh - 60px);
    width: calc(100vw - 100px);
}

.topContainer {
    justify-content: space-between;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f5f5f5;
    box-sizing: border-box;
    padding: 0px 30px;
    height: 60px;
    width: 100%;
    position: absolute;
    z-index: 10;
}
</style>
